<template>
  <div class="summary-grid" :class="darkMode ? 'dark' : ''">
    <div class="date">
      <div class="label f8">{{ topDate }}</div>
      <div class="value f2">{{ booking.title }}</div>
    </div>
    <div class="players">
      <div
        class="label f8"
      >{{ booking.numPlayers }} {{ $tc('Player | Players', booking.numPlayers) }}</div>
      <div
        class="value f2"
      >{{ bookingStationTimesWithoutRemoved.length }} {{ $tc('Station | Stations', bookingStationTimesWithoutRemoved.length) }}</div>
    </div>
    <BookingPrice
      v-if="!isOrganizationEducation"
      :locationId="locationId"
      :bookingStationTimes="bookingStationTimesWithoutRemoved"
      :darkMode="darkMode"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import moment from 'moment-timezone';
import BookingPrice from '@/location/price-components/BookingPrice';

export default {
  components: {
    BookingPrice,
  },
  props: {
    locationId: {
      type: String,
      required: true,
    },
    twentyFourHourTime: {
      type: Boolean,
      required: true,
    },
    booking: {
      type: Object,
      required: true,
    },
    bookingStationTimesWithoutRemoved: {
      type: Array,
      required: true,
    },
    longestTierLength: {
      type: Number,
      required: true,
    },
    startTime: {
      type: String,
      required: true,
    },
    isOrganizationEducation: {
      type: Boolean,
      default: false,
    },
    darkMode: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    topDate () {
      const startTime = moment(this.startTime);

      if (this.bookingStationTimesWithoutRemoved.length) {
        let time = `${startTime.format('LL')} | `;
        if (this.twentyFourHourTime) {
          time += `${startTime.format('H:mm')} - ${startTime.add(this.longestTierLength, 'minutes').format('H:mm')}`;
        } else {
          time += `${startTime.format('h:mm A')} - ${startTime.add(this.longestTierLength, 'minutes').format('h:mm A')}`;
        }
        return time;
      }

      return null;
    },
  },
};
</script>

<style lang="postcss" scoped>
@import "core/shared/styles";

.summary-grid {
  background-color: var(--colorWhite);
  max-width: 100rem;

  & .date,
  & .players {
    margin-bottom: var(--spacingSm);

    @media (--tablet) {
      margin-bottom: 0;
      margin-right: var(--spacingSm);
    }
  }

  @media (--tablet) {
    display: flex;
    & > * {
      flex: 1 1 0;
    }
  }

  & .label {
    margin-bottom: var(--spacingXS);
    color: var(--colorManatee);
  }

  & .value {
    margin: 0;
  }
}

.summary-grid.dark {
  background-color: var(--darkModeColorDarkBackground) !important;
}
</style>
